import {
  GET,
  POST
} from "@/axios/axios"

export const services = {
  UserLogin: (param) => { // 登录
    return POST("/backend/user/login", param);
  },
  getCashCode: (param) => {   // 获取验证码
    return GET('/backend/sendMessage/getSignInCode', param)
  },
  LoginCode: () => { // 登录验证码使用
    return GET("/merchant/sendMessage/getVerifyCodeImage");
  },
  LogOut: () => { // 退出登录
    return GET("/backend/user/loginOut");
  },
  AmendPassword: (param) => { // 修改密码
    return POST("/backend/user/updatePassword", param);
  },
  SidebarList: (param) => { // 侧边栏
    return GET("/backend/role/getMenu", param);
  },
  HomePageList: (param) => { // 首页
    return GET("/backend/custom/index", param);
  },
  getButton: (param) => { // 获取按钮
    return GET("/backend/role/getButton", param);
  },
  visualizeData: (param) => { // 可视化-充值
    return GET("/backend/index/visualize/backstage", param);
  },
  pending: (param) => { // 可视化-待办事项
    return GET("/backend/index/visualize/backstage/pending", param);
  },
  ranking: (param) => { // 可视化-排行榜
    return GET("/backend/custom/visualiz/backstage/ranking", param);
  },
  userData: (param) => { // 可视化-用户数据
    return GET("/backend/index/visualize/backstage/userData", param);
  },
  backstageData: (param) => { // 可视化数据-充值/开票/发放
    return GET("/backend/index/visualize/backstage/data", param);
  },
  resetPasswordPos: (param) => { // 重置密码
    return GET("/auth/user/resetPasswordPos", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/user.js